import Decimal from "decimal.js";

export const complement = (n: Decimal) => Decimal(1).minus(n);

export const compoundDiscounts = (...rates: Decimal[]) =>
  rates.reduce((a, b) => complement(complement(a).mul(complement(b))), new Decimal(0));
